import React, {useCallback, useEffect, useRef, useState} from "react";
import {
    IonBackdrop,
    IonButton,
    IonCol,
    IonContent, IonGrid,
    IonHeader,
    IonItem,
    IonLabel, IonModal, IonPage,
    IonRow,
    IonTabButton, IonToast,
    IonToolbar,
    IonButtons, IonTitle, useIonModal, IonFooter, IonIcon, IonThumbnail, IonCardSubtitle
} from "@ionic/react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Text from "../CommonStyles/Text";
import "./iframe.css"
import axios from "axios";
import styled from "@emotion/styled";
import './index.css';
import {Link, useNavigate} from "react-router-dom";
import CheckBox from "../../components/CheckBox/Index"
import {OverlayEventDetail} from "@ionic/react/dist/types/components/react-component-lib/interfaces";
import {formatMoney} from "../../util/formatHelpers";
import {usStates} from "../../constants";
import {
    add,
    arrowBack,
    chevronDownOutline,
    chevronUpOutline,
    closeOutline
} from "ionicons/icons";
import CurrencyInput from "react-currency-input-field";
import RegistrationPage from "./RegistrationPage";
import {getConfig} from "../../AppConfig";
import jwt_decode from "jwt-decode";
import moment from "moment";
import dayjs, {Dayjs} from "dayjs";
import {loadStripe} from '@stripe/stripe-js';
import { useDebouncedCallback } from 'use-debounce';

const Span = styled.span`
  padding-left: 0.5em;
`

const SpanImage = styled.span`
  margin-top: 5px;
`

const Image = styled.img`
  height: 30px;
`

export const Input = styled("input")`
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  height: 60px;
  width: 100%;
  border-radius: 10px;
  background-color: #e0ebf180;
  outline: none;
  border: 1px solid #66666660;
  padding-left: 15px;
  ::placeholder {
    font-size: 14px;
    padding-left: 0px;
  }
`;

const Select = styled("select")`
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  height: 60px;
  border-radius: 10px;
  background-color: #e0ebf180;
  outline: none;
  border: 1px solid #66666660;
  padding-left: 15px;
  ::placeholder {
    font-size: 14px;
    padding-left: 0px;
  }
`

const Option = styled("option")`
  box-sizing: border-box;
  background-color: #0000000d;
  outline: none;
  border: none;
  ::placeholder {
    font-size: 14px;
    padding-left: 4px;
  }
`

const ModalContent = styled.div`
      margin-top: 32px;
      margin-left: 32px;
      margin-right: 32px;
      height: 32em;
      text-align: left;
  
      h1 {
        font-family: var(--ion-font-family);
        font-size: 33px;
        font-weight: bold;
        text-align: center;
      }
      h2 {
        font-family: var(--ion-font-family);
        font-size: 26px;
        //font-weight: bold;
        text-align: center;
      }
      p {
        font-family: var(--ion-font-family);
      }
      letter-spacing: 0px;
      color: #333333;
    `


const LogoModalContent = styled.div`
      //margin-top: 32px;
      //margin-left: 32px;
      //margin-right: 32px;
      height: 32em;
      text-align: center;
  
      h1 {
        font-family: var(--ion-font-family);
        font-size: 23px;
        font-weight: bold;
        text-align: center;
      }
      h2 {
        font-family: var(--ion-font-family);
        font-size: 16px;
        //font-weight: bold;
        text-align: center;
      }
      p {
        font-family: var(--ion-font-family);
      }
      letter-spacing: 0px;
      color: #333333;
    `


const MessageModal = ({
                          onDismiss,
                          message,
                      }: {
    onDismiss: (data?: string | null | undefined | number, role?: string) => void;
    message: string;
}) => {
    const inputRef = useRef<HTMLIonInputElement>(null);
    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>Complete Registration</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding">
                <IonItem>
                    <IonLabel class={'ion-text-wrap'} style={{ fontSize: '18px'}}>{message}</IonLabel>
                </IonItem>
            </IonContent>
            <IonFooter>
                <IonRow style={{marginBottom: '20px'}}>
                    <IonCol style={{display: 'flex'}} className="ion-justify-content-center">
                        <IonButton onClick={() => onDismiss(inputRef.current?.value, 'cancel')} size="large" style={{ width: '80%' }} expand="block" fill="solid" color={'primary'}>
                            Cancel
                        </IonButton>
                    </IonCol>
                    <IonCol style={{display: 'flex'}} className="ion-justify-content-center">
                        <IonButton onClick={() => onDismiss(inputRef.current?.value, 'ok')} size="large" style={{ width: '80%' }} expand="block" fill="solid" color={'primary'}>
                            Ok
                        </IonButton>
                    </IonCol>
                </IonRow>
            </IonFooter>
        </IonPage>
    );
};

const RegisterPage = ({showCart, storeData, setStoreData, eventcode, auctioncode, reloadData, setReloadData, internalReload, setInternalReload}) => {
    const domainName =  window.location.hostname
    const domainNames = domainName.split('.')
    const [selectedTab, setSelectedTab] = React.useState('')
    const [hasNonFreeTypeItems, setHasNonFreeTypeItems] = React.useState(false)

    let interval;
    const [message, setMessage] = useState('Click OK to submit your guest registration information. If you have any changes to make later, use the “Update Registration” link found in your purchase receipt email or contact the event organizer.');
    const [present, dismiss] = useIonModal(MessageModal, {
        onDismiss: (data: string, role: string) => dismiss(data, role),
        message: message,
    });

    useEffect(()=> {
        // const handleStorageChange = (event) => {
        //     console.log('STORAGE!!')
        //     console.log(event)
        // }
        //
        // window.addEventListener('storage', handleStorageChange)
        // setReloadData(reloadData+1)
        // setInternalReload(internalReload+1)

        return () => {
            // window.removeEventListener('storage', handleStorageChange);
            // setTimerReload(timerReload+1)
            setReloadData(reloadData+1)
        }
    }, [])

    const debouncedClick = useDebouncedCallback(
        (value, item) => {
            quantityBlur(value, item);
        },
        // delay in ms
        100
    );

    const getStoreSetupData = async () => {
        const body = {auctioncode: auctioncode, eventcode: eventcode}
        const token = localStorage.getItem('tokenstore')

        const headers = token  ? {'Authorization': `Bearer ${token}`} : {}
        let url = `${apiUrl}/storesetup2`
        const {data} = await axios.post(url, body, {headers: headers})
        var parsedJson = JSON.parse(data?.jsonInfo)
        console.log(parsedJson)
        parsedJson.hasMerch = false
        parsedJson.hastickets = false
        parsedJson?.tabs?.map(tab => {
            if (tab.tabname == 'Merchandise') {
                if (tab?.sections?.length > 0) {
                    tab.sections.map(section => {
                        if (section?.data?.length > 0) {
                            const oneitme = section.data.find(item => item?.id > 0)
                            if (oneitme?.id > 0) {
                                parsedJson.hasMerch = true
                                tab.enabled = true
                            }
                            else {
                                tab.enabled = false
                            }
                        }
                    })
                }
            }
            if (tab.tabname == 'Tickets') {
                if (tab?.sections?.length > 0) {
                    tab.sections.map(section => {
                        if (section?.data?.length > 0) {
                            const oneitme = section.data.find(item => item?.id > 0)
                            if (oneitme?.id > 0) {
                                parsedJson.hastickets = true
                                tab.enabled = true
                            }
                            else {
                                tab.enabled = false
                            }
                        }
                    })
                }
            }
        })
        if (parsedJson.status === 'expired') {
            localStorage.removeItem("tokenstore")
            // history.push(`/${eventcode}/event`);
        }
        else if (parsedJson?.token?.length > 0) {
            console.log('setting token')
            localStorage.setItem('tokenstore', parsedJson.token)
        }
        if (parsedJson && parsedJson.tabs) {
            if (parsedJson.hascheckedout) {
                setSelectedTab('Cart')
            }
            else {
                if (parsedJson.hastickets) {
                    setSelectedTab(parsedJson.tabs[0].tabname)
                }
                else if (parsedJson.hasMerch) {
                    setSelectedTab(parsedJson.tabs[1].tabname)
                }
                else {
                    setSelectedTab('Cart')
                }
            }
        }
        if (showCart === 'cart') {
            console.log('setting cart')
            setSelectedTab('Cart')
        }

        setStoreData({...storeData, ...parsedJson})
    }

    useEffect(() => {
        // setStoreData(setup1data)
        if (internalReload > 1) {
            getStoreSetupData()
        }
    }, [internalReload])

    // useEffect(()=> {
    //     // setTimerReload(timerReload+1)
    //     setInternalReload(internalReload+1)
    // }, [])

    function openRegistrationModal() {
        present({
            onWillDismiss: (ev: CustomEvent<OverlayEventDetail>) => {
                if (ev.detail.role === 'ok') {
                    localStorage.removeItem("tokenstore")
                    setReloadData(reloadData+1)
                    // setInternalReload(internalReload+1)
                    navigate(`/${eventcode}/event/`);
                }
            },
        });
    }

    function onWillDismiss(ev: CustomEvent<OverlayEventDetail>) {
        if (ev.detail.role === 'confirm') {
            console.log('confirm')
        }
        setQuantityModal({active: false, quantity: 0, item:''})
        if (summaryModal.active) {
            setSummaryModal({active: false})
            goFinish()
        }
    }

    const emailRegex =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/


    const [itemQuantity, setItemQuantity] = React.useState({})
    const [itemPrice, setItemPrice] = React.useState({})
    const [cartExpired, setCartExpired] = React.useState(false)
    const [timerReload, setTimerReload] = React.useState<number>(null)
    const [paymentProcessFeesCheckbox, setPaymentProcessFeesCheckbox] = useState(false)
    const [toastState, setToastState] = useState({display: false, goback: false, message: ''})
    const [isLoading, setIsLoading] = useState(false)
    const [additionalDonation, setAdditionalDonation] = useState<number>(0)
    const [additionalDonationFinal, setAdditionalDonationFinal] = useState<number>(0)
    const [promoCodeAmount, setPromoCodeAmount] = useState<number>(0)
    const [promoCodeMessage, setPromoCodeMessage] = useState<string>('')
    const [promoCode, setPromoCode] = useState<string>("")
    const [orderTotal, setOrderTotal] = useState(0)
    const [subtotalTotal, setSubtotalTotal] = useState(0)
    const [ccTotal, setCCTotal] = useState(0)
    const [ccTotalFee, setCCTotalFee] = useState(0)
    const [finishCheckout, setFinishCheckout] = useState(false)
    const [lstMessage, setListMessage] = useState<string | undefined>(undefined)
    const [firstname, setFirstName] = useState<string>("")
    const [lastname, setLastName] = useState<string>("")
    const [address1, setAddress1] = useState<string>("")
    const [city, setCity] = useState<string>("")
    const [state, setState] = useState<string>("AL")
    const [zip, setZip] = useState<string>("")
    const [email, setEmail] = useState<string>("")
    const [paymentmethod, setPaymentMethod] = useState<string>("CREDIT")
    const [processorToken, setProcessorToken] = useState('');
    const [stripeObj, setStripeObj] = useState(null)
    const [reloadStripeElement, setReloadStripeElement] = useState<number>(0)
    const [stripeElement, setStripeElement] = useState(null)
    const [stripeAPIKey, setStripeAPIKey] = useState('')
    const [stripeCurrency, setStripeCurrency] = useState('usd')
    const [stripeAccountId, setStripeAccountId] = useState('')
    const [stripePaymentElement, setStripePaymentElement] = useState(null)
    const [invalidateIframe, setInvalidateIframe] = React.useState(1)

    const [cartData, setCartData] = React.useState({
        cartitems: [],
        allowpaymentoffees: false,
        hascheckedout: false,
        requiredemail: false,
        requiredzip: false,
        billme: false,
        ccfee: 0,
        paymentprocessorcode: 0,
        paymentprocessorisvalid: true,
        paymentprocessorinfo: {
            stripeaccountid: '',
            stripeapikey: '',
            stripecurrency: '',
            creditcardiframe: 'https://secure.1stpaygateway.net/secure/PaymentHostedForm/v3/CreditCard',
            javascriptfile: 'https://secure.1stpaygateway.net/secure/PaymentHostedForm/Scripts/firstpay/firstpay.cryptogram.js',
            processorid: "70802",
            transactiontype: "Sale",
            transcenterid: "92754",
        },
        discountamount: 0,
        discountcode: '',
        hasdiscount: true,
        message: '',
        first: "",
        last: "",
        address: "",
        city: "",
        state: "",
        zip: "",
        email: "",
        paymentmethod: "",
        optionaltotal: 0,
        subtotal: 0,
        totalamount: 0,
        additionaldonation: undefined,
        logourl: '',
        itemtypecode: '',
    })

    const getStoreSetup = async () => {
        setStoreData({
            storewelcomeeventname: '',
            storewelcomeheader: '',
            storewelcomeeventlogourl: '',
            storewelcomebuttonevent: '',
            storewelcomebuttonauction: '',
            storewelcomebuttoneventshow: true,
            storewelcomebuttonauctionshow: true,
            torewelcomefooter: '',
            storewelcomeauctionlink: '',
            tabs: [],
            token: '',
            hascheckedout: false,
            hasmerch: true,
            hastickets: true,
            logourl: '',
            itemtypecode: '',
        })

        const body = {auctioncode: auctioncode, eventcode: eventcode}
        const token = localStorage.getItem('tokenstore')

        const headers = token  ? {'Authorization': `Bearer ${token}`} : {}
        let url = `${apiUrl}/storesetup2`
        const {data} = await axios.post(url, body, {headers: headers})
        const parsedJson = JSON.parse(data?.jsonInfo)

        if (parsedJson.status === 'expired') {
            localStorage.removeItem("tokenstore")
            navigate(`/${eventcode}/event`);
        }
        else if (parsedJson.token) {
            localStorage.setItem('tokenstore', parsedJson.token)
            setStoreData(parsedJson)
            // setTimerReload(parsedJson.token)
            // setTokenInternal(parsedJson.token)
        }
        else {
            setStoreData(parsedJson)
        }
    }

    const options = {
        mode: 'payment',
        amount: orderTotal * 100,
        paymentMethodCreation: 'manual',
        // currency: 'usd',
        // paymentMethodTypes: ['card', 'us_bank_account'],
        //confirm = true,
        setupFutureUsage: 'off_session',
    };

    const loadStripeAccount = async () => {
        const stripeTempObj = await loadStripe(stripeAPIKey, {
            stripeAccount: stripeAccountId,
        });
        setStripeObj(stripeTempObj);
    }

    useEffect(() => {
        if (stripeObj && !stripePaymentElement && orderTotal > 0) {
            const elements = stripeObj.elements({...options, currency: stripeCurrency});
            setStripeElement(elements)
            const paymentElement = elements.create('payment', {
                layout: {
                    type: 'tabs',
                    defaultCollapsed: false,
                },
            });
            paymentElement.mount('#payment-element');

            paymentElement.on('change', async function(event) {
                if (event.complete) {
                    console.log('Stripe Form - complete')

                    await elements.submit();
                    const {error, confirmationToken} = await stripeObj.createConfirmationToken({elements: elements})
                    if (confirmationToken) {
                        setProcessorToken(confirmationToken.id)
                    }
                }
            });
            setStripePaymentElement(paymentElement)
        }
    }, [stripeObj, reloadStripeElement])

    useEffect(() => {
        if (cartData?.paymentprocessorcode === 2) {
            if (cartData?.paymentprocessorinfo?.stripecurrency?.length > 0) {
                setStripeCurrency(cartData?.paymentprocessorinfo?.stripecurrency)
            }
            if (cartData?.paymentprocessorinfo?.stripeapikey) {
                setStripeAPIKey(cartData?.paymentprocessorinfo?.stripeapikey)
            }
            if (cartData?.paymentprocessorinfo?.stripeaccountid) {
                setStripeAccountId(cartData?.paymentprocessorinfo?.stripeaccountid)
            }
        }
    }, [cartData?.paymentprocessorinfo?.stripeaccountid])

    useEffect(() => {
        if (stripeAPIKey && stripeAPIKey.length > 0) {
            loadStripeAccount()
        }
    }, [stripeAPIKey, stripeAccountId])

    useEffect(() => {
        let token = localStorage.getItem("tokenstore")
        var decoded: any = ''
        if (token) {
            decoded = jwt_decode(token)

            const tokenDate = dayjs.unix(decoded.exp)
            const nowDate: any = moment()
            if (tokenDate.isAfter(nowDate)) {
                interval = setInterval(() => {
                    function pad(n) {
                        return (n < 10 ? "0" + n.toString() : n);
                    }

                    if (storeData?.tabs.find(item => item.tabname === 'Registration').enabled) {
                        clearInterval(interval)
                        setListMessage('')
                    }
                    else {
                        const d = dayjs.unix(decoded.exp)
                        const then: any = moment()
                        const now: any = moment(d.toDate(), "YYYY-MM-DD hh:mm:ss")

                        const calcSeconds = now.diff(then, 'seconds')
                        const days = Math.floor(calcSeconds / 24 / 60 / 60);
                        const hoursLeft = Math.floor((calcSeconds) - (days * 86400));
                        const hours = Math.floor(hoursLeft / 3600);
                        const minutesLeft = Math.floor((hoursLeft) - (hours * 3600));
                        const minutes = Math.floor(minutesLeft / 60);
                        const remainingSeconds = calcSeconds % 60;

                        // console.log(days + ' : ' + hours + ' : ' + minutes + ' : ' + remainingSeconds)
                        const currentDate: any = moment()
                        // console.log(currentDate)
                        // console.log(tokenDate.isBefore(currentDate))
                        if (tokenDate.isBefore(currentDate)) {
                            setListMessage('Cart Expired. Please reload the page')
                            localStorage.removeItem("tokenstore")
                            // setReloadData(reloadData + 1)
                            clearInterval(interval)
                            interval = null;
                            setCartExpired(true)
                        }
                        else if (Number(days) > 0) {
                            setListMessage('Cart Expires in ' + pad(days) + "d " + pad(hours) + "h " + pad(minutes) + 'm ' + pad(remainingSeconds) + 's')
                            setCartExpired(false)
                        } else if (Number(hours) > 0) {
                            setListMessage('Cart Expires in ' + pad(hours) + "h " + pad(minutes) + 'm ' + pad(remainingSeconds) + 's')
                            setCartExpired(false)
                        } else if (Number(minutes) > 0) {
                            setListMessage('Cart Expires in ' + pad(minutes) + 'm ' + pad(remainingSeconds) + 's')
                            setCartExpired(false)
                        } else if (Number(remainingSeconds) > 0) {
                            setListMessage('Cart Expires in ' + pad(remainingSeconds) + 's')
                            setCartExpired(false)
                        } else {
                            setListMessage('Cart Expired. Please reload the page')
                            localStorage.removeItem("tokenstore")
                            // setReloadData(reloadData + 1)
                            clearInterval(interval)
                            interval = null;
                            setCartExpired(true)
                            // setInternalReload(internalReload+1)
                            // navigate(`/${eventcode}/event`);
                        }
                    }

                }, 1000)
            }
            else {
                setListMessage('Cart Expired. Please reload the page')
                localStorage.removeItem("tokenstore")
                clearInterval(interval)
                interval = null;
                setCartExpired(true)
            }
        }
        return () => {
            clearInterval(interval)
        }
    }, [timerReload])

    const [quantityModal, setQuantityModal] = React.useState({active: false, quantity: 0, item: ""})
    const [logoModal, setLogoModal] = React.useState({active: false, url: '', name: "", desc: ""})
    const [summaryModal, setSummaryModal] = React.useState({active: false})
    const [maxQuantityPerTransModel, setMaxQuantityPerTransModal] = React.useState({active: false, maxquantity: 0, name: ""})

    const { apiUrl } = getConfig()
    const navigate = useNavigate()
    const storeCartAddItemUrl = `${apiUrl}/storecartadditem`
    const cartItemUrl = `${apiUrl}/storecart`
    const storecartdiscount = `${apiUrl}/storecartdiscount`
    const checkoutUrl = `${apiUrl}/storecheckout`
    const storeguestUrl = `${apiUrl}/storeguest`
    const checkoutTab = 'Checkout'

    useEffect(() => {
        const quantity = {...itemQuantity}
        const prices = {...itemPrice}
        storeData?.tabs?.map((item, index) => {
            item.sections.map(section => {
                section.data.map(itemdata => {
                    if (itemdata && itemdata.id > 0) {
                        quantity[itemdata.id] = Number(itemdata.quantity)
                        prices[itemdata.id] =  '$' + itemdata.price * Number(itemdata.quantity)
                    }
                })
            })
        })
        setItemQuantity(quantity)
        setItemPrice(prices)
        setTimerReload(timerReload+2)
    }, [storeData])

    useEffect(() => {
        setOrderTotal(0)
        const donation = Number(additionalDonationFinal)
        const discount = Number(promoCodeAmount)
        const subtotal = Number(subtotalTotal)
        const ccfee = cartData.ccfee / 100
        const ccTotalFee = (ccfee * (subtotal + donation - discount))
        setCCTotal(ccfee)
        setCCTotalFee(ccTotalFee)
        if (paymentProcessFeesCheckbox) {
            setOrderTotal(
                subtotal + donation + ccTotalFee - discount
            )
            setReloadStripeElement(reloadStripeElement+1)
        }
        else if (subtotal + donation - discount > 0) {
            setCCTotal(0)
            setOrderTotal(subtotal + donation - discount)
            setReloadStripeElement(reloadStripeElement+1)
        }
    }, [
        additionalDonationFinal,
        paymentProcessFeesCheckbox,
        subtotalTotal,
        promoCodeAmount
    ])


    useEffect(() => {
        if (selectedTab === 'Cart') {
            getCartItems()
        }
    }, [selectedTab])

    useEffect(() => {
        const script = document.createElement("script")

        script.src = cartData?.paymentprocessorinfo?.javascriptfile
        script.id =  "firstpay-script-cryptogram"
        script.type = "text/javascript"

        script.setAttribute("data-transcenter", cartData?.paymentprocessorinfo?.transcenterid)
        script.setAttribute("data-processor", cartData?.paymentprocessorinfo?.processorid)

        document.body.appendChild(script)

        var subtotal = 0
        cartData?.cartitems?.map((item) => {
            subtotal += item.lineamount
        })
        setSubtotalTotal(subtotal)

        if (cartData) {
            setFirstName(cartData.first)
            setLastName(cartData.last)
            setAddress1(cartData.address)
            setCity(cartData.city)
            setState(cartData.state)
            setZip(cartData.zip)
            setEmail(cartData.email)
            if (cartData && cartData?.paymentmethod && cartData?.paymentmethod !== "0") {
                console.log('setting up payment method - ' + cartData?.paymentmethod)
                setPaymentMethod(cartData.paymentmethod)
            }
            else {
                console.log('setting up payment method - CREDIT')
                setPaymentMethod('CREDIT')
            }

            setPromoCode(cartData.discountcode)
            setPromoCodeAmount(cartData.discountamount)
            setAdditionalDonationFinal(0)
            if (Number(cartData.additionaldonation) > 0) {
                setAdditionalDonation(cartData.additionaldonation)
                setAdditionalDonationFinal(cartData.additionaldonation)
            }
            else {
                setAdditionalDonation(0);
                setAdditionalDonationFinal(0);
            }
        }
    }, [cartData])

    useEffect(() => {
        setPaymentMethod('BILLME')

        window.addEventListener("message", processPayment, false)
        return () => {
            window.removeEventListener("message", processPayment)
        }
    }, [])

    const processPayment = (e: any) => {
        if (e.data.firstpay) {
            const ccData = e.data
            if (ccData.type === 'newCryptogram') {
                setProcessorToken(ccData.cryptogram)
            }
        }
    }

    const clickCheckout = async () => {
        clearInterval(interval)
        setIsLoading(true)

        if (orderTotal > 0 && paymentmethod === "CREDIT" && (!processorToken || processorToken.length <= 0)) {
            setIsLoading(false)
            return setToastState({ display: true, goback: false, message: `Please enter a valid credit card.`})
        }
        else if (!firstname) {
            setIsLoading(false)
            return setToastState({ display: true, goback: false, message: `First name is required for checkout.`})
        }
        else if (!lastname) {
            setIsLoading(false)
            return setToastState({ display: true, goback: false, message: `Last name is required for checkout.`})
        }
        else if (!address1) {
            setIsLoading(false)
            return setToastState({ display: true, goback: false, message: `Address is required for checkout.`})
        }
        else if (!city) {
            setIsLoading(false)
            return setToastState({ display: true, goback: false, message: `City is required for checkout.`})
        }
        else if (!state) {
            setIsLoading(false)
            return setToastState({ display: true, goback: false, message: `State is required for checkout.`})
        }
        else if (!zip) {  //&& cartData?.requiredzip) {
            setIsLoading(false)
            return setToastState({ display: true, goback: false, message: `Zip is required for checkout.`})
        }
        else if (cartData?.requiredemail && !emailRegex.test(email)) {
            setIsLoading(false)
            return setToastState({ display: true, goback: false, message: `Please enter a valid email.`})
        }
        else {
            const body = {
                "first":firstname,
                "last":lastname,
                "address":address1,
                "city":city,
                "state":state,
                "zip":zip,
                "email":email,
                "subtotal": subtotalTotal,
                "discountamount": promoCodeAmount,
                "additionaldonation": additionalDonationFinal,
                "ccfeesamount": ccTotal,
                "totalamount": orderTotal,
                "paymentmethod": orderTotal > 0 ? paymentmethod : 'FREE',
                "processortoken": processorToken
            }
            const token = localStorage.getItem('tokenstore')

            const {data} = await axios.put(checkoutUrl, body, {headers: {
                    'Authorization': `Bearer ${token}`
                }})
            const parsedData = JSON.parse(data.jsonString)
            if (parsedData.status === 'expired') {
                localStorage.removeItem("tokenstore")
                // setReloadData(reloadData+1)
                // setInternalReload(internalReload+1)
                navigate(`/${eventcode}/event`);
            }
            if (parsedData.status === 'success') {
                if (parsedData && parsedData?.token) {
                    localStorage.setItem('tokenstore', parsedData.token)
                    await getStoreSetup()
                    storeData.tabs.map((tab, index) => {
                        if (tab.tabname === selectedTab) {
                            setSelectedTab(storeData.tabs[index + 1].tabname)
                        }
                    })
                }
                else {
                    // goFinish()
                    setSummaryModal({active: true})
                }
            }
            else if (parsedData.status === 'failed') {
                return setToastState({ display: true, goback: false, message: parsedData?.message})
            }
        }
    }

    const getCartItems = async () => {
        const body = {}
        const token = localStorage.getItem('tokenstore')

        const {data} = await axios.get(cartItemUrl, {headers: {
                'Authorization': `Bearer ${token}`
            }})
        const parsedData = JSON.parse(data.jsonString)
        if (parsedData.status === 'expired') {
            localStorage.removeItem("tokenstore")
            navigate(`/${eventcode}/event`);
        }
        else if (parsedData.status === 'success') {
            setCartData(parsedData)
            setInvalidateIframe(invalidateIframe+1)
            setStripePaymentElement(null)
            setReloadStripeElement(reloadStripeElement+1)
        }
    }

    const getDiscount = async (discountcode) => {
        const body = {"discountcode": discountcode}
        const token = localStorage.getItem('tokenstore')

        const {data} = await axios.post(storecartdiscount, body, {headers: {
                'Authorization': `Bearer ${token}`
            }})
        const parsedData = JSON.parse(data.jsonString)
        if (parsedData.status === 'expired') {
            localStorage.removeItem("tokenstore")
            // setReloadData(reloadData+1)
            // setInternalReload(internalReload+1)
            navigate(`/${eventcode}/event`);
        }
        else if (parsedData.status === 'success') {
            console.log(parsedData.discountamount)

            return {discountamount: parsedData.discountamount, message: parsedData.message}
        }
        else {
            return {discountamount: 0, message: parsedData.message}
        }
    }

    const validSectionData = (data) => {
        var valid = true
        if (data && data?.length > 0) {
            data.map(item => {
                if (item && item?.id > 0) {
                    valid = true
                    return
                }
                else {
                    valid = false
                    return
                }
            })
        }
        else {
            valid = false
            return
        }

        return valid
    }

    const quantityUpdate = async (value, item) => {
        // if (item.quantity >= 0) {
            if (item.maxquantitypertransaction >= Number(value) || item.maxquantitypertransaction == 0) {
                const quantity = {...itemQuantity}
                quantity[item.id] = Number(value)
                setItemQuantity(quantity)

                var prices = {...itemPrice}
                prices[item.id] =  '$' + item.price * value
                console.log(item.price * value)
                setItemPrice(prices)
            }
            else {
                setMaxQuantityPerTransModal({active: true, maxquantity: item.maxquantitypertransaction, name: item.name})
            }
        // }
    }

    const quantityBlur = async (value, item) => {
        console.log(item)
        const body = {quantity: Number(value), itemid: Number(item.id)}
        const token = localStorage.getItem('tokenstore')

        if (item?.maxquantitypertransaction < value) {
            const quantity = {...itemQuantity}
            quantity[item.id] = Number(item.maxquantitypertransaction)

            var prices = {...itemPrice}
            prices[item.id] =  '$' + item.price * quantity[item.id]
            setItemPrice(prices)
            setItemQuantity(quantity)
            setMaxQuantityPerTransModal({active: true, maxquantity: item.maxquantitypertransaction, name: item.name})
        }
        else {
            const {data} = await axios.post(storeCartAddItemUrl, body, {headers: {
                    'Authorization': `Bearer ${token}`
                }})
            const parsedData = JSON.parse(data.jsonString)
            if (parsedData.status === 'expired') {
                localStorage.removeItem("tokenstore")
                setReloadData(reloadData+1)
                // setInternalReload(internalReload+1)
                navigate(`/${eventcode}/event`);
            }
            else if (parsedData.status === 'failure') {
                const quantity = {...itemQuantity}
                quantity[parsedData.itemid] = Number(parsedData.quantityremaining)
                setItemQuantity(quantity)
                setQuantityModal({active: true, quantity: parsedData.quantityremaining, item: parsedData.itemname})
            }
        }
    }

    const calcItemPrice = (item) => {
        // console.log('calcItemPrice')
        // console.log(item.price)
        var quantityValue = itemQuantity[item.id]
        if (item.maxquantitypertransaction > quantityValue) {
            quantityValue = item.maxquantitypertransaction
        }

        const priceUnformatted = Number(itemPrice[item.id]?.split("$").pop())
        const total = formatMoney(priceUnformatted)
        const price = formatMoney(item.price)

        var totalPrice = (item.id in itemPrice) ? `X ${price} = ${total}` : `X ${price} = $0`
        if (item.itemtypecode == 4) {
            totalPrice = "FREE"
        }

        return totalPrice
    }

    const goBack = () => {
        storeData.tabs.map((tab, index) => {
            if (tab.tabname === selectedTab) {
                if (tab.tabname == 'Cart') {
                    if (storeData.hasMerch) {
                        setSelectedTab(storeData.tabs[index - 1].tabname)
                    }
                    else {
                        setSelectedTab(storeData.tabs[index - 2].tabname)
                    }
                }
                else {
                    setSelectedTab(storeData.tabs[index - 1].tabname)
                }
            }
        })
    }
    const goNext = () => {
        storeData.tabs.map((tab, index) => {
            if (tab.tabname === selectedTab) {
                if (tab.tabname == 'Tickets') {
                    if (storeData.hasMerch) {
                        setSelectedTab(storeData.tabs[index + 1].tabname)
                    }
                    else {
                        setSelectedTab(storeData.tabs[index + 2].tabname)
                    }
                }
                else {
                    setSelectedTab(storeData.tabs[index + 1].tabname)
                }
            }
        })
    }

    const saveAndContinue = () => {
        navigate(`/${eventcode}/event/`);
    }

    const goFinish = () => {
        if (selectedTab === 'Registration') {
            openRegistrationModal()
        }
        else {
            localStorage.removeItem("tokenstore")
            setReloadData(reloadData+1)
            navigate(`/${eventcode}/event/`);
        }
    }

    const hasNext = () => {
        var nextBool = false
        storeData?.tabs?.map((tab, index) => {
            if (tab.tabname === selectedTab) {
                if (storeData.tabs.length > (index + 1)) {
                    nextBool = true
                }
            }
        })
        return nextBool
    }

    const hasBack = () => {
        var nextBool = false
        storeData?.tabs?.map((tab, index) => {
            if (tab.tabname === selectedTab) {
                if (index > 0) {
                    nextBool = true
                }
            }
        })
        return nextBool
    }

    const disableCheckout = () => {
        if (cartExpired) {
            return true
        }
        else if (Number(additionalDonationFinal) > 0) {
            return false
        }
        else if (cartData?.cartitems?.length <= 0) {
            return true
        }
        else if (cartData?.cartitems?.length > 0) {
            return false
        }
        else if (Number(additionalDonationFinal) <= 0 || additionalDonationFinal == undefined) {
            return true
        }
        else {
            return false
        }
    }

    const getButtons = () => {
        // scotty
        const cartButton = (
                <IonCol style={{display: 'flex'}} className="ion-justify-content-center ion-col-custom">
                    <IonButton disabled={disableCheckout()} onClick={() => {clickCheckout()}} size="large" style={{ maxWidth: '600px', width: '500px' }} expand="block" fill="solid" color={'primary'}>
                        Checkout
                    </IonButton>
                </IonCol>
        )

        const backButton = (
                <IonCol style={{display: 'flex'}} className="ion-justify-content-center ion-col-custom">
                    <IonButton disabled={cartExpired} onClick={goBack} size="large" style={{ maxWidth: '600px', width: '500px' }} expand="block" fill="solid" color={'primary'}>
                        Back
                    </IonButton>
                </IonCol>
        )
        const nextButton = (
                <IonCol style={{display: 'flex'}} className="ion-justify-content-center ion-col-custom">
                    <IonButton disabled={cartExpired} onClick={goNext} size="large" style={{ maxWidth: '600px', width: '500px' }} expand="block" fill="solid" color={'primary'}>
                        Next
                    </IonButton>
                </IonCol>
        )


        if (finishCheckout || (cartData?.hascheckedout && !storeData?.tabs.find(item => item.tabname === 'Registration').enabled)) {
            return  (
                <IonRow>
                    <IonCol style={{display: 'flex'}} className="ion-justify-content-center ion-col-custom">
                        <IonButton onClick={goFinish} size="large" style={{ maxWidth: '600px', width: '500px' }} expand="block" fill="solid" color={'primary'}>
                            Finish
                        </IonButton>
                    </IonCol>
                </IonRow>
            )
        }
        else if (selectedTab === 'Cart') {
            if (storeData?.hascheckedout) {
                return (
                    <>
                        <IonRow>
                            {nextButton}
                        </IonRow>
                    </>
                )
            }
            else {
                return (
                    <>
                        <IonRow>
                            {backButton}
                            {cartButton}
                        </IonRow>
                    </>
                )
            }
        }
        else if (hasBack() && hasNext()) {
            return (
                <>
                    <IonRow>
                        {backButton}
                        {nextButton}
                    </IonRow>
                </>
            )
        }
        else if (hasNext()) {
            return nextButton
        }
        else {
            return  (
                <IonRow>
                    {/*<IonCol style={{display: 'flex'}} className="ion-justify-content-center ion-col-custom">*/}
                    {/*    <IonButton onClick={saveAndContinue} size="large" style={{ width: '80%' }} expand="block" fill="solid" color={'primary'}>*/}
                    {/*        Save and Continue Later*/}
                    {/*    </IonButton>*/}
                    {/*</IonCol>*/}
                    <IonCol style={{display: 'flex'}} className="ion-justify-content-center ion-col-custom">
                        <IonButton onClick={goFinish} size="large" style={{ maxWidth: '600px', width: '500px' }} expand="block" fill="solid" color={'primary'}>
                            Finish
                        </IonButton>
                    </IonCol>
                </IonRow>
            )
        }
    }

    const calcAmountWon = () => {
        return cartData.cartitems.reduce((acc: any, curr: any) => {
            return acc + curr.lineamount
        }, 0)
    }

    const addAdditionalDonation = (value) => {
        if (value.float > 100000) {
            setAdditionalDonation(100000)
            setAdditionalDonationFinal(100000)
            return
        }
        else {
            setAdditionalDonation(value.float)
            setAdditionalDonationFinal(value.float)
        }
    }

    const getDiscountAmount = async () => {
        const discountObj = await getDiscount(promoCode)
        setPromoCodeAmount(discountObj.discountamount)
        setPromoCodeMessage(discountObj.message)
    }

    const updatePromoCode =  (e: any) => {
        if(e.target.value < 0){
            return
        }
        setPromoCode(e.target.value)
    }

    const GoEmerchant = () => {
        return (
            <div >
                <SpanImage id="goe-logo">Payment securely processed by: <a href="https://goemerchant.com" target="_blank">
                    <Image alt="goEmerchant Payment Processing" src="https://donorsnap.com/graphics/entry/goe-logo.png"></Image>
                </a></SpanImage>
            </div>
        )
    }

    const displayLogoUrl = (item) => {
        if (item?.logourl && item?.logourl?.length > 0) {
            setLogoModal({active: true, url: item?.logourl, name: item?.name, desc: item?.description})
        }
    }

    const getDataItems = (items) => {
        const elems = items?.map((item) => {
            if (item && item?.name?.length > 0) {
                return (
                    <>
                        <IonRow class={'ion-justify-content-center ion-align-items-center'}>
                            <IonCol sizeLg="6" sizeMd="6" sizeSm="6" sizeXs='12' onClick={() => { displayLogoUrl(item) }}>
                                <IonItem class={'ion-no-padding ion-no-margin'} lines={'none'}>
                                    {(item?.logourl && item?.logourl.length > 0) &&
                                        <IonThumbnail style={{marginRight: '10px'}}>
                                            <img alt="" src={item?.logourl} />
                                        </IonThumbnail>
                                    }

                                    <IonLabel class={'ion-text-wrap'} style={{fontSize: '16px'}}>
                                        <h2>{item.name}</h2>
                                        <p>{item.description}</p>
                                    </IonLabel>
                                </IonItem>
                            </IonCol>
                            <IonCol sizeLg="6"  sizeMd="6" sizeSm="6" sizeXs='12'>
                                <IonGrid>
                                    <IonRow class={'ion-no-padding'}>
                                        {/*<IonCol sizeXl={'8'} sizeLg="12" sizeMd="12" sizeSm="12" sizeXs="12" style={{border: "1px solid #dadada"}} class={'ion-align-items-end ion-justify-content-center ion-align-items-center'}>*/}
                                            <IonItem lines={'none'} style={{ float: 'left',
                                                clear: 'both'}}>
                                            {(item?.isquantityunlimited || item?.quantityremaining > 0) &&
                                                <>
                                                    <Input
                                                        type="number"
                                                        id=""
                                                        min={0}
                                                        placeholder=""
                                                        name=""
                                                        width={'100%'}
                                                        style={{minWidth: '70px', maxWidth: '70px'}}
                                                        disabled={storeData?.hascheckedout || cartExpired}
                                                        onChange={(e) => {
                                                            quantityUpdate(e.target.value, item)
                                                        }}
                                                        onBlur={(e) => {quantityBlur(e.target.value, item)}}
                                                        value={itemQuantity[item.id]}
                                                        defaultValue={itemQuantity[item.id] > 0 ? itemQuantity[item.id] : 0}
                                                    />

                                                    <IonItem lines={'none'} style={{float: 'left',
                                                        clear: 'both'}}>
                                                        <IonButtons slot="end" onClick={() => {
                                                            quantityUpdate(itemQuantity[item.id] > 0 ? itemQuantity[item.id] - 1 : 0, item)
                                                            debouncedClick(itemQuantity[item.id] > 0 ? itemQuantity[item.id] - 1 : 0, item);
                                                        }}
                                                        >
                                                            <IonIcon
                                                                // slot="icon-only"
                                                                icon={chevronDownOutline}
                                                                style={{width: 30, height: 30, color: "#000000"}}
                                                            />
                                                        </IonButtons>
                                                        <IonButtons slot="end"
                                                            onClick={(e) => {
                                                                quantityUpdate(itemQuantity[item.id] + 1, item);
                                                                debouncedClick(itemQuantity[item.id] + 1, item);
                                                            }}
                                                        >
                                                            <IonIcon
                                                                // slot="icon-only"
                                                                icon={chevronUpOutline}
                                                                style={{width: 30, height: 30, color: "#000000"}}
                                                            />
                                                        </IonButtons>
                                                    </IonItem>
                                                </>
                                            }
                                                {/*<IonItem lines={'none'} style={{border: "1px solid #dadada", float: 'left',*/}
                                                {/*    clear: 'both'}}>*/}
                                                {/*    {(!item?.isquantityunlimited && item?.quantityremaining <= 0) &&*/}
                                                {/*        <IonLabel style={{ marginLeft: '10px', fontSize: '16px'}}>SOLD OUT</IonLabel>*/}
                                                {/*    }*/}
                                                {/*    {(item?.isquantityunlimited || item?.quantityremaining > 0) &&*/}
                                                {/*        <IonLabel style={{ marginLeft: '10px', fontSize: '16px'}}>{calcItemPrice(item)}</IonLabel>*/}
                                                {/*    }*/}
                                                {/*</IonItem>*/}
                                            </IonItem>
                                        {/*</IonCol>*/}
                                        {/*<IonCol sizeXl={'4'} sizeLg="12" sizeMd="12" sizeSm="12" sizeXs="12" class={'ion-no-padding ion-justify-content-center ion-align-items-center'}>*/}
                                            <IonItem lines={'none'} style={{float: 'left',
                                                clear: 'both'}}>
                                            {(!item?.isquantityunlimited && item?.quantityremaining <= 0) &&
                                                <IonLabel style={{ marginLeft: '10px', fontSize: '16px'}}>SOLD OUT</IonLabel>
                                            }
                                            {(item?.isquantityunlimited || item?.quantityremaining > 0) &&
                                                <IonLabel style={{ marginLeft: '10px', fontSize: '16px'}}>{calcItemPrice(item)}</IonLabel>
                                            }
                                            </IonItem>
                                        {/*</IonCol>*/}
                                    </IonRow>
                                </IonGrid>
                            </IonCol>
                        </IonRow>
                    </>
                )
            }
        })
        return (
            <>
                {elems}
            </>
        )
    }

    const getCart = () => {
        var subtotal = 0
        const detailRows = cartData?.cartitems?.map((item) => {
            subtotal += item.lineamount
            return (
                <IonRow class={'ion-justify-content-center ion-align-items-center'}>
                    <IonCol>
                        <IonItem lines={'none'}>
                            <IonLabel style={{ marginLeft: '10px', fontSize: '16px'}}>{item.name}</IonLabel>
                        </IonItem>
                    </IonCol>
                    <IonCol class={'ion-justify-content-end'}>
                        <IonItem lines={'none'}>
                            <>
                            {item.itemtypecode == 4 &&
                                <IonLabel class={'ion-text-right'} style={{ marginLeft: '10px', fontSize: '16px'}}>{item.quantity + ' FREE'} </IonLabel>
                            }
                            {item.itemtypecode != 4 &&
                                <IonLabel class={'ion-text-right'} style={{ marginLeft: '10px', fontSize: '16px'}}>{item.quantity + ' X $' + item.price + ' = $' + item.lineamount }</IonLabel>
                            }
                            </>
                        </IonItem>
                    </IonCol>
                </IonRow>
            )
        })

        return (
            <>
                {detailRows}
                {cartData?.cartitems &&
                    <IonRow class={'ion-justify-content-center ion-align-items-center'} >
                        <IonCol class={'ion-justify-content-end'} >
                            <IonItem lines={'none'} >
                                <IonLabel class={'ion-text-right'} style={{ marginLeft: '10px', fontSize: '16px'}}>{'Subtotal: ' + formatMoney(subtotal) }</IonLabel>
                            </IonItem>
                        </IonCol>
                    </IonRow>
                }

                {cartData?.paymentprocessorisvalid &&
                <IonRow class={'ion-justify-content-center ion-align-items-center'}>
                    <IonCol class={'ion-justify-content-end'} >
                        <IonItem lines={'none'} >
                            <IonLabel class={'ion-text-left'} style={{ marginLeft: '10px', fontSize: '16px'}}>{'Additional Donation'}</IonLabel>
                        </IonItem>
                    </IonCol>
                    <IonCol class={'ion-justify-content-end'} >
                        <IonItem class={'ion-align-items-end'} lines={'none'} >
                            <div className={'right-align-input'}>
                                <CurrencyInput
                                    // id="input-example"
                                    intlConfig={{ locale: 'en-US', currency: 'USD' }}
                                    name="additionalDonation"
                                    style={{  display: 'flex-end', justifyContent: 'flex-end', boxSizing: 'border-box', height: '60px', borderRadius: '10px',
                                        textAlign: 'right', backgroundColor: "#e0ebf180", outline: 'none', border: "1px solid #66666660", paddingRight: '10px', paddingLeft: '15px'}}
                                    placeholder="$0"
                                    // autoFocus={false}
                                    // defaultValue={0}
                                    decimalsLimit={0}
                                    disabled={cartData?.hascheckedout}
                                    // onValueChange={(value, name, values) => console.log(value, name, values)}
                                    onValueChange={(value, name, values) => {
                                        addAdditionalDonation(values)
                                    }}
                                    // value={additionalDonation}
                                    // prefix={'$'}
                                />
                            </div>
                        </IonItem>
                    </IonCol>
                </IonRow>
                }
                {cartData?.cartitems && cartData?.paymentprocessorisvalid &&
                    <>
                    <IonRow class={'ion-justify-content-center ion-align-items-center'}>
                        <IonCol class={'ion-align-items-end'} >
                            <IonItem lines={'none'} >
                                <Input
                                    id="promo-code"
                                    placeholder="Promo Code"
                                    value={String(promoCode)}
                                    // onBlur={(e) => {
                                    //     getDiscountAmount(e)
                                    // }}
                                    onChange={(e) => {
                                        updatePromoCode(e)
                                    }}
                                    disabled={cartData?.hascheckedout || orderTotal === 0}
                                />
                                <IonButton disabled={cartData?.hascheckedout || orderTotal === 0} expand="full" className="ion-color-secondary ion-text-center ion-text-wrap ion-align-items-center ion-wrap"
                                           ion-button fill="clear" onClick={getDiscountAmount}>
                                    <IonLabel class={'ion-text-left'} style={{ fontSize: '16px'}}>{'Apply Promo Code'}</IonLabel>
                                </IonButton>
                            </IonItem>
                        </IonCol>
                        <IonCol >
                            <IonItem class={'ion-align-items-center'} lines={'none'} >
                                <IonLabel class={'ion-text-right'} style={{ fontSize: '16px'}}>{'Promo Code: ' + formatMoney(promoCodeAmount) }</IonLabel>
                            </IonItem>
                        </IonCol>
                    </IonRow>
                    {promoCodeMessage?.length > 0 &&
                        <IonRow>
                            <IonCol class="ion-padding-bottom">
                                <IonLabel color="danger" class={'ion-text-left'} style={{ marginLeft: '25px',  fontSize: '18px'}}>{promoCodeMessage}</IonLabel>
                            </IonCol>
                        </IonRow>
                    }
                    </>
                }
                {cartData.allowpaymentoffees && cartData?.paymentprocessorisvalid &&
                    <IonRow class={'ion-justify-content-center ion-align-items-center'}>
                        <IonCol class={'ion-align-items-end'}>
                            <IonItem class={'ion-align-items-end'} lines={'none'} >
                                <div className={'left-align-input'}>
                                    <label>
                                        <CheckBox
                                            name="item"
                                            checked={paymentProcessFeesCheckbox}
                                            handleCheckboxChange={(e: any) =>
                                                setPaymentProcessFeesCheckbox(e.target.checked)
                                            }
                                            param="item"
                                            checkedBackgroundColor="#5732db"
                                            uncheckedBackgroundColor="white"
                                            height="24px"
                                            width="24px"
                                            borderRadius="5px"
                                            disabled={cartData?.hascheckedout}
                                        >
                                        </CheckBox>
                                    </label>
                                    <Span>Add {(Math.round(cartData.ccfee * 100) / 100).toFixed(2)}% to cover payment processing fees</Span>
                                </div>
                            </IonItem>
                        </IonCol>
                        {paymentProcessFeesCheckbox &&
                            <IonCol class={'ion-justify-content-end'} >
                                <IonItem lines={'none'} >
                                    <IonLabel class={'ion-text-right'} style={{ marginLeft: '10px', fontSize: '16px'}}>{'Processing fees: ' + formatMoney(ccTotalFee) }</IonLabel>
                                </IonItem>
                            </IonCol>
                        }
                    </IonRow>
                }
                <IonRow class={'ion-justify-content-end'} >
                    <IonCol class={'ion-justify-content-end'} >
                        <IonItem lines={'none'} >
                            <IonLabel class={'ion-text-right'} style={{ marginLeft: '10px', fontSize: '16px'}}>{'Total: ' + formatMoney(orderTotal) }</IonLabel>
                        </IonItem>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol class={'ion-justify-content-end'}>
                        <div className={'right-align-input'}>
                            <Input
                                type="text"
                                style={{width: '100%'}}
                                placeholder="First Name"
                                value={firstname}
                                disabled={cartData?.hascheckedout || finishCheckout}
                                required={true}
                                onChange={(e) => {
                                    setFirstName(e.currentTarget.value)
                                }}
                            />
                        </div>
                    </IonCol>
                    <IonCol>
                        <Input
                            type="text"
                            style={{width: '100%'}}
                            placeholder="Last Name"
                            value={lastname}
                            required={true}
                            disabled={cartData?.hascheckedout || finishCheckout}
                            onChange={(e) => {
                                setLastName(e.currentTarget.value)
                            }}
                        />
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                        <div className={'center-align-input'}>
                            <Input
                                type="text"
                                style={{width: '100%'}}
                                placeholder="Address"
                                required={true}
                                value={address1}
                                disabled={cartData?.hascheckedout || finishCheckout}
                                onChange={(e) => {
                                    setAddress1(e.currentTarget.value)
                                }}
                            />
                        </div>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol >
                        <div  style={{width: '100%'}} className={'left-align-input'}>
                            <Input
                                type="text"
                                style={{width: '100%'}}
                                placeholder="City"
                                value={city}
                                required={true}
                                disabled={cartData?.hascheckedout || finishCheckout}
                                onChange={(e) => {
                                    setCity(e.currentTarget.value)
                                }}
                            />
                        </div>
                    </IonCol>
                    <IonCol size="auto">
                        <div style={{width: '120px'}} className={'right-align-input'}>
                            <Select
                                name="state"
                                id="id"
                                style={{width: '100%'}}
                                value={state}
                                required={true}
                                disabled={cartData?.hascheckedout || finishCheckout}
                                onChange={(e) => {
                                    setState(e.currentTarget.value)
                                }}
                                // defaultValue={userData.addressInfo.state}
                            >
                                {usStates.map((stateO, index) => {
                                    return (
                                        // <Option value={state.abbreviation} key={index} selected={}>
                                        <Option value={stateO.abbreviation} key={index}>
                                            {stateO.abbreviation}
                                        </Option>
                                    )
                                })}
                            </Select>
                        </div>
                    </IonCol>
                    <IonCol size="auto">
                        <div style={{width: '160px'}} className={'right-align-input'}>
                            <Input
                                type="text"
                                style={{width: '100%'}}
                                placeholder="Zip"
                                // required={cartData?.requiredzip}
                                required={true}
                                value={zip}
                                disabled={cartData?.hascheckedout || finishCheckout}
                                onChange={(e) => {
                                    setZip(e.currentTarget.value)
                                }}
                            />
                        </div>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                        <div style={{width: '100%'}} className={'center-align-input'}>
                            <Input
                                type="text"
                                style={{width: '100%'}}
                                placeholder="Email"
                                value={email}
                                required={true}
                                // required={cartData?.requiredemail}
                                disabled={cartData?.hascheckedout || finishCheckout}
                                onChange={(e) => {
                                    setEmail(e.currentTarget.value)
                                }}
                            />
                        </div>
                    </IonCol>
                </IonRow>
                {cartData?.billme &&
                    <>
                        <IonRow>
                            <IonCol>
                                <div className={'right-align-input'}>
                                    <Select
                                        name="state"
                                        id="id"
                                        style={{width: '100%'}}
                                        value={paymentmethod}
                                        disabled={cartData?.hascheckedout || finishCheckout || orderTotal === 0}
                                        onChange={(e) => {
                                            console.log(e.currentTarget.value)
                                            setPaymentMethod(e.currentTarget.value)
                                        }}
                                        // defaultValue={userData.addressInfo.state}
                                    >
                                        {orderTotal === 0 &&
                                            <Option value={'FREE'} key={'free'}>
                                                {'FREE'}
                                            </Option>
                                        }
                                        {orderTotal > 0 &&
                                            <>
                                                <Option value={'CREDIT'} key={'cc'} selected={paymentmethod === 'CREDIT'}>
                                                    {'Credit / Debit Card'}
                                                </Option>
                                                <Option value={'BILLME'} key={'bm'} selected={paymentmethod === 'BILLME'}>
                                                    {'Bill Me'}
                                                </Option>
                                            </>
                                        }
                                    </Select>
                                </div>
                            </IonCol>
                        </IonRow>
                    </>
                }

                {(paymentmethod === "CREDIT" && orderTotal > 0 && !cartData?.hascheckedout && cartData?.paymentprocessorcode === 1) &&
                    <>
                        <IonRow style={{ paddingLeft: "15px", marginTop: "10px" }}>
                            <IonCol>
                                <GoEmerchant/>
                            </IonCol>
                        </IonRow>
                    </>
                }
                {/*{(cartData?.hascheckedout === false) &&*/}
                    <IonRow>
                        <IonCol>
                            <iframe
                                key={invalidateIframe}
                                title="1stpayment-iframe"
                                id="firstpay-iframe"
                                src={ cartData?.paymentprocessorinfo?.creditcardiframe }
                                data-transcenter-id={ cartData?.paymentprocessorinfo?.transcenterid }
                                data-processor-id={ cartData?.paymentprocessorinfo?.processorid }
                                data-transaction-type={ cartData?.paymentprocessorinfo?.transactiontype }
                                data-manual-submit="false"
                                style={{display: (paymentmethod === "CREDIT" && cartData?.paymentprocessorcode === 1 && orderTotal > 0 ? 'inline' : 'none')}}
                            />
                            {/*{(cartData?.paymentprocessorcode === 2 && paymentmethod === "CREDIT") &&*/}
                                <div hidden={paymentmethod !== "CREDIT" && cartData?.paymentprocessorcode !== 2 && (orderTotal === 0 || orderTotal === undefined)} id="payment-element"></div>
                            {/*}*/}
                        </IonCol>
                    </IonRow>
                {/*}*/}
            </>
        )
    }

    const inputRef = useRef<HTMLIonInputElement>(null);

    return (
        <>
            <IonToast
                isOpen={toastState.display}
                onDidDismiss={() => {
                    if (toastState.goback) {
                        navigate(-1)
                    }
                    setToastState({
                        display: false,
                        goback: false,
                        message: ''
                    })
                }}
                cssClass={'custom-toast'}
                message={toastState.message}
                duration={3000}
            />
            {summaryModal.active &&
                <IonModal
                    isOpen={true}
                    onWillDismiss={(ev) => onWillDismiss(ev)}
                >
                    <IonBackdrop />
                    <ModalContent>
                        <h1>{"Checkout Successful"}</h1>
                        <h2>Purchase Summary</h2>
                        {/*<IonRow style={{marginTop: '20px'}}>*/}
                        {/*    <IonCol size="12" className="ion-justify-content-begin">*/}
                        {/*        <Text textAlign="left"  fontWeight="800" fontSize="22px" color="#0a0a0a" >*/}
                        {/*            {firstname + ' ' + lastname + ' - ' + email}*/}
                        {/*        </Text>*/}
                        {/*    </IonCol>*/}
                        {/*</IonRow>*/}
                        {/*<IonRow style={{marginTop: '10px'}}>*/}
                        {/*    <IonCol size="12" className="ion-justify-content-begin">*/}
                        {/*        <Text textAlign="left"  fontWeight="800" fontSize="22px" color="#0a0a0a" >*/}
                        {/*            {address1 + ' ' + city + ', ' + state + ' ' + zip}*/}
                        {/*        </Text>*/}
                        {/*    </IonCol>*/}
                        {/*</IonRow>*/}
                        <IonRow style={{marginTop: '10px'}}>
                            <IonCol size="8" className="ion-justify-content-begin">
                                <Text textAlign="left"  fontSize="20px" color="#0a0a0a" >
                                    {'Subtotal:'}
                                </Text>
                            </IonCol>
                            <IonCol size="4">
                                <Text textAlign="right" fontSize="18px" color="#0a0a0a">
                                    {'$' + subtotalTotal}
                                </Text>
                            </IonCol>
                        </IonRow>
                        <IonRow style={{marginTop: '5px'}}>
                            <IonCol size="8" className="ion-justify-content-begin">
                                <Text textAlign="left"  fontSize="20px" color="#0a0a0a" >
                                    {'Discount:'}
                                </Text>
                            </IonCol>
                            <IonCol size="4">
                                <Text textAlign="right" fontSize="18px" color="#0a0a0a">
                                    {'$' + promoCodeAmount}
                                </Text>
                            </IonCol>
                        </IonRow>
                        <IonRow style={{marginTop: '5px'}}>
                            <IonCol size="8" className="ion-justify-content-begin">
                                <Text textAlign="left"  fontSize="20px" color="#0a0a0a" >
                                    {'Additional Donation:'}
                                </Text>
                            </IonCol>
                            <IonCol size="4">
                                <Text textAlign="right" fontSize="18px" color="#0a0a0a">
                                    {'$' + additionalDonationFinal}
                                </Text>
                            </IonCol>
                        </IonRow>
                        <IonRow style={{marginTop: '5px'}}>
                            <IonCol size="8" className="ion-justify-content-begin">
                                <Text textAlign="left"  fontSize="20px" color="#0a0a0a" >
                                    {'CC Fees:'}
                                </Text>
                            </IonCol>
                            <IonCol size="4">
                                <Text textAlign="right" fontSize="18px" color="#0a0a0a">
                                    {'$' + ccTotal}
                                </Text>
                            </IonCol>
                        </IonRow>
                        <IonRow style={{marginTop: '5px'}}>
                            <IonCol size="8" className="ion-justify-content-begin">
                                <Text textAlign="left"  fontSize="20px" color="#0a0a0a" >
                                    {'Total Amount:'}
                                </Text>
                            </IonCol>
                            <IonCol size="4">
                                <Text textAlign="right" fontSize="18px" color="#0a0a0a">
                                    {'$' + orderTotal}
                                </Text>
                            </IonCol>
                        </IonRow>
                        <IonRow style={{marginTop: '5px'}}>
                            <IonCol size="8" className="ion-justify-content-begin">
                                <Text textAlign="left"  fontSize="20px" color="#0a0a0a" >
                                    {'Payment Method:'}
                                </Text>
                            </IonCol>
                            <IonCol size="4">
                                <Text textAlign="right" fontSize="18px" color="#0a0a0a">
                                    {paymentmethod}
                                </Text>
                            </IonCol>
                        </IonRow>
                    </ModalContent>
                    <IonRow style={{marginBottom: '20px'}}>
                        <IonCol style={{display: 'flex'}} className="ion-justify-content-center">
                            <IonButton onClick={() => { setQuantityModal({active: false, quantity: 0, item:''})}} size="large" style={{ width: '80%' }} expand="block" fill="solid" color={'primary'}>
                                Close
                            </IonButton>
                        </IonCol>
                    </IonRow>
                </IonModal>
            }
            {logoModal.active &&
                <IonModal
                    isOpen={true}
                    onWillDismiss={(ev) => {}}
                    backdropDismiss={false}
                    // initialBreakpoint={0.5}
                >
                    <LogoModalContent>
                        <IonToolbar>
                            <IonTitle>{logoModal.name}</IonTitle>
                            <IonButtons slot="end" onClick={() => { setLogoModal({active: false, url: '', name:'', desc: ''})}}>
                                <IonIcon
                                    // slot="icon-only"
                                    icon={closeOutline}
                                    style={{width: 30, height: 30, color: "#000000"}}
                                />
                            </IonButtons>
                        </IonToolbar>

                        <IonRow>
                            <IonCol>
                                {(logoModal?.url && logoModal?.url.length > 0) &&
                                    <img style={{maxWidth: '425px', maxHeight: '425px'}} alt="" src={logoModal?.url} />
                                }
                            </IonCol>
                        </IonRow>
                        <IonCardSubtitle style={{marginTop: '15px'}}>{logoModal.desc}</IonCardSubtitle>
                    </LogoModalContent>
                </IonModal>
            }
            {quantityModal.active &&
                <IonModal
                    isOpen={true}
                    onWillDismiss={(ev) => onWillDismiss(ev)}
                >
                    <IonBackdrop />
                    <ModalContent>
                        <h1>{"Insuffcient Quantity Available"}</h1>
                        <h2>{"We're sorry, but the quantity available is lower than you seleced:"}</h2>
                        <IonRow style={{marginTop: '20px'}}>
                            <IonCol size="6" className="ion-justify-content-begin">
                                <Text textAlign="right"  fontWeight="800" fontSize="18px" color="#a2a2a2" >
                                    {quantityModal.item + ':'}
                                </Text>
                            </IonCol>
                            <IonCol size="6">
                                    <Text textAlign="left" fontWeight="800" fontSize="18px" color="#a2a2a2">
                                        {quantityModal.quantity + ' Remaining'}
                                    </Text>
                            </IonCol>
                        </IonRow>
                    </ModalContent>
                    <IonRow style={{marginBottom: '20px'}}>
                        <IonCol style={{display: 'flex'}} className="ion-justify-content-center">
                            <IonButton onClick={() => { setQuantityModal({active: false, quantity: 0, item:''})}} size="large" style={{ width: '80%' }} expand="block" fill="solid" color={'primary'}>
                                Ok
                            </IonButton>
                        </IonCol>
                    </IonRow>
                </IonModal>
            }
            {maxQuantityPerTransModel.active &&
                <IonModal
                    isOpen={true}
                    onWillDismiss={(ev) => onWillDismiss(ev)}
                >
                    <IonBackdrop />
                    <ModalContent>
                        <h1>{"Max quantity per transaction exceeded"}</h1>
                        <h2>{"We're sorry, but the max quantity per transaction was exceeded:"}</h2>
                        <IonRow style={{marginTop: '20px'}}>
                            <IonCol size="6" className="ion-justify-content-begin">
                                <Text textAlign="right"  fontWeight="800" fontSize="18px" color="#a2a2a2" >
                                    {maxQuantityPerTransModel.name + ':'}
                                </Text>
                            </IonCol>
                            <IonCol size="6">
                                <Text textAlign="left" fontWeight="800" fontSize="18px" color="#a2a2a2">
                                    {maxQuantityPerTransModel.maxquantity + ' Max'}
                                </Text>
                            </IonCol>
                        </IonRow>
                    </ModalContent>
                    <IonRow style={{marginBottom: '20px'}}>
                        <IonCol style={{display: 'flex'}} className="ion-justify-content-center">
                            <IonButton onClick={() => { setQuantityModal({active: false, quantity: 0, item:''})}} size="large" style={{ width: '80%' }} expand="block" fill="solid" color={'primary'}>
                                Ok
                            </IonButton>
                        </IonCol>
                    </IonRow>
                </IonModal>
            }

            <IonContent style={{height: '100%'}}>
                <IonHeader>
                    <IonToolbar>
                        <IonButtons slot={'start'} >
                            <IonButton onClick={() => {navigate(`/${eventcode}/event/`)}} fill="solid" color="black" >
                                <IonIcon
                                    icon={arrowBack}
                                    slot="icon-only"
                                    color={"medium"}
                                    style={{ width: 20, height: 20, paddingRight: '5px' }}
                                    onClick={() => {navigate(`/${eventcode}/event/`)}}
                                />
                                    <Text
                                        className={"ion-hide-md-down"}
                                        style={{overflow: 'hidden'}}
                                        fontSize="13px"
                                        color="black"
                                        textAlign="center"
                                        // flexWrap={'wrap'}
                                    >
                                        Back to Event Home
                                    </Text>

                            </IonButton>
                        </IonButtons>

                        <IonTitle>
                            <IonButton expand="full" className="ion-color-secondary ion-text-center ion-text-wrap ion-align-items-center ion-wrap">
                            <Text
                                fontSize="18px"
                                color="#000"
                                fontWeight="bold"
                                textAlign="center"
                                flexWrap={'wrap'}
                            >
                                {storeData?.storewelcomeeventname}
                            </Text>
                            </IonButton>
                        </IonTitle>
                    </IonToolbar>
                    {/*<IonToolbar style={{border: '1px solid'}}>*/}
                        <Text
                            fontSize="18px"
                            color="#000"
                            fontWeight="bold"
                            textAlign="center"
                            flexWrap={'wrap'}
                            padding={'5px'}
                        >
                            {lstMessage}
                        </Text>
                    {/*</IonToolbar>*/}

                    <IonToolbar>
                        <IonRow>
                            {storeData && storeData?.tabs && storeData?.tabs.map((item, index) => {
                                return (
                                    <IonCol onClick={() => {
                                        if (item.enabled) {
                                            setSelectedTab(item.tabname)
                                        }
                                    }}>
                                        <IonTabButton disabled={!item.enabled} selected={selectedTab === item.tabname}>
                                            <FontAwesomeIcon size="3x" icon={item.image}/>
                                            <IonLabel>{item.tabname}</IonLabel>
                                        </IonTabButton>
                                    </IonCol>
                                )
                            })}
                        </IonRow>
                    </IonToolbar>
                </IonHeader>
                <IonGrid>
                {storeData && storeData?.tabs && storeData?.tabs.map((item, index) => {
                    if (item.tabname !== selectedTab) {
                        return;
                    }
                    // if (item.tabname === 'Cart' && selectedTab === 'Cart' && item.heading === checkoutTab) {
                    if (item.tabname === 'Cart') {
                        return (
                            <>
                                {item?.heading?.length > 0 &&
                                    <IonRow>
                                        <IonLabel style={{marginLeft: '15px', marginTop: '10px', fontSize: '26px'}}><b>{item.heading}</b></IonLabel>
                                    </IonRow>
                                }
                                <>
                                    {getCart()}
                                </>
                            </>
                        )
                    }
                    else if (item.tabname === 'Registration' ) {
                        return (
                            <>
                                <RegistrationPage storeData={storeData} setStoreData={setStoreData}
                                                  item={item} eventcode={eventcode} auctioncode={auctioncode} />
                            </>
                        )
                    }
                    else if (selectedTab === item.tabname) {
                        return (
                            <>
                                {item?.heading?.length > 0 &&
                                    <IonRow>
                                        <IonLabel style={{marginLeft: '15px', marginTop: '10px', fontSize: '26px'}}><b>{item.heading}</b></IonLabel>
                                    </IonRow>
                                }

                                {item.sections.map((section) => {
                                    if (section && section.sectionheading && validSectionData(section.data)) {
                                        return (
                                            <>
                                                <IonRow>
                                                    <IonLabel style={{marginLeft: '15px', marginTop: '10px', fontSize: '26px'}}><b>{section.sectionheading}</b></IonLabel>
                                                </IonRow>
                                                {getDataItems(section.data)}
                                            </>
                                        )
                                    }
                                })}
                            </>
                        )
                    }
                })}
                    {getButtons()}
                </IonGrid>
                <div style={{width: '75%', margin: 'auto', borderTop: "1px solid #666", marginTop: '50px', backgroundColor: 'transparent'}}>
                    <div style={{verticalAlign: 'middle', color: '#666', marginTop: '5px', marginBottom: "0px", backgroundColor: 'transparent', position: "relative", padding:"0 0 0 0", textAlign: "center", fontSize: 12}}>
                        EventSnap™. All Rights Reserved by DonorSnap.{" "}<br />
                        <span style={{ color: "red" }}>
                    <a><Link style={{ textDecoration: 'none' }} to={"/" + eventcode + "/privacy-policy"}>Privacy Policy</Link></a>
                  </span>
                    </div>
                </div>
            </IonContent>
        </>
    )
}

export default RegisterPage